import { Building2 } from "lucide-react";

interface StartupBannerProps {
  bannerUrl: string | null;
  name: string;
}

export const StartupBanner = ({ bannerUrl, name }: StartupBannerProps) => {
  return (
    <div className="relative mb-8">
      {bannerUrl ? (
        <img
          src={bannerUrl}
          alt={name}
          className="w-full h-64 object-cover rounded-lg"
        />
      ) : (
        <div className="w-full h-64 bg-gradient-to-br from-flux-cyan/20 to-flux-cyan/5 rounded-lg flex items-center justify-center">
          <Building2 className="w-24 h-24 text-flux-cyan/40" />
        </div>
      )}
    </div>
  );
};